import { render } from "./ServicePage.vue?vue&type=template&id=1e7c2e6e&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=1e7c2e6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7c2e6e"]])

export default __exports__